module.exports = __webpack_public_path__ + "img/cookies_raa.8ca49f0d.jpg";